import { useRooms } from '../../hooks/useRooms';
import { useCurrentInstitution } from '../institutions/useCurrentInstitution';
import { useGetUserId } from '../../hooks/useCredentials';
import { useEffect } from 'react';
import { useGrowthBookConfig } from '../useGrowthBookConfig';
import { MembershipType } from '../../services';

export const usePersonalRoom = (): {
  id: string | undefined;
  passcode: string | null;
  roomUrl: string;
  cameraOff?: boolean;
  usePasscode: boolean;
  slug: string;
} => {
  const userId = useGetUserId();
  const { institution } = useCurrentInstitution();
  const { updateGrowthBookConfig } = useGrowthBookConfig();

  const { rooms } = useRooms({
    userId,
    institutionId: institution?.id ?? null,
  });

  const room = rooms?.find(
    (r) => r.node.membershipType === MembershipType.Owner,
  )?.node;
  const roomId = room?.id;
  const origin = typeof window === 'undefined' ? '' : window.location.origin;
  const roomUrl = `${origin}/${room?.slug ?? ''}`;

  /**
   * Add the roomId to the GrowthBook config for the provider.
   */
  useEffect(() => {
    updateGrowthBookConfig({ roomId });
  }, [roomId]);

  return {
    passcode: room?.passcode || null,
    cameraOff: room?.cameraOff,
    roomUrl,
    id: room?.id,
    usePasscode: room?.isPasscodeEnabled ?? false,
    slug: room?.slug ?? '',
  };
};
